import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import "./Chat.css";
import { sendTelegramMessage } from "../utils/telegram";

const INITIAL_FORM_DATA = {
  name: "",
  lastName: "",
  email: "",
  phone: "",
};

function ChatUser() {
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState(INITIAL_FORM_DATA);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const message = `
📩 *New Application Received!*
👤 *Name:* ${formData.name} ${formData.lastName}
📧 *Email:* ${formData.email}
📞 *Phone:* ${formData.phone}
    `.trim();
    try {
      await sendTelegramMessage(message);
      toast.success("The message has been sent successfully!");
      setFormData(INITIAL_FORM_DATA);
      setShowModal(false);
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error(
        error?.message || "Failed to send message. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="chat_user">
      <button className="chat_btn" onClick={() => setShowModal(true)}>
        <svg
          stroke="currentColor"
          fill="currentColor"
          strokeWidth="0"
          viewBox="0 0 640 512"
          height="24"
          width="24"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M621.3 237.3l-58.5-58.5c-12-12-28.3-18.7-45.3-18.7H480V64c0-17.7-14.3-32-32-32H32C14.3 32 0 46.3 0 64v336c0 44.2 35.8 80 80 80 26.3 0 49.4-12.9 64-32.4 14.6 19.6 37.7 32.4 64 32.4 44.2 0 80-35.8 80-80 0-5.5-.6-10.8-1.6-16h163.2c-1.1 5.2-1.6 10.5-1.6 16 0 44.2 35.8 80 80 80s80-35.8 80-80c0-5.5-.6-10.8-1.6-16H624c8.8 0 16-7.2 16-16v-85.5c0-17-6.7-33.2-18.7-45.2zM80 432c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm128 0c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32zm272-224h37.5c4.3 0 8.3 1.7 11.3 4.7l43.3 43.3H480v-48zm48 224c-17.6 0-32-14.4-32-32s14.4-32 32-32 32 14.4 32 32-14.4 32-32 32z"></path>
        </svg>
      </button>

      {showModal && (
        <div className="chat_modal_overlay" onClick={() => setShowModal(false)}>
          <form
            className="chat_modal_content"
            onClick={(e) => e.stopPropagation()}
            onSubmit={handleSubmit}
          >
            <h4>
              Hiring <span>Experienced</span> Drivers
            </h4>
            <p className="chat_modal_content_p">
              Do not miss the opportunity, join our family!
            </p>

            <input
              type="text"
              name="name"
              placeholder="Name"
              value={formData.name}
              onChange={handleChange}
              required
            />
            <input
              type="text"
              name="lastName"
              placeholder="Last name"
              value={formData.lastName}
              onChange={handleChange}
              required
            />
            <input
              type="email"
              name="email"
              placeholder="Email address"
              value={formData.email}
              onChange={handleChange}
              required
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone number"
              value={formData.phone}
              onChange={handleChange}
              required
            />

            <button
              type="submit"
              className="chat_send_btn"
              disabled={loading}
              aria-busy={loading}
            >
              {loading ? "Sending..." : "Send"}
            </button>
            <button
              type="button"
              className="chat_app_btn"
              onClick={() => {
                window.location.href =
                  "https://dashboard.getdoublenickel.com/short-form/hjdx7vjrb";
              }}
            >
              Full Application
            </button>
            <button
              type="button"
              className="chat_modal_close_btn"
              onClick={() => setShowModal(false)}
            >
              <FontAwesomeIcon icon={faClose} />
            </button>
          </form>
        </div>
      )}
    </div>
  );
}

export default ChatUser;
